<template>
  <div style="overflow-x: hidden">
    <div class="invisibleStep pa-2 fill-height step2 " style="overflow: hidden">
      <div class="fill-height introStep introStep1" v-show="introSlider === 1">
        <div class="fill-height text-center">
          <img src="../../assets/image/user-journey/slide3.svg" alt="">
          <div class="titleStep">
            انتخاب یه روانشناس مناسب، تصادفی نیست، راهکار داره
          </div>
          <div class="contentStep">
            برای پیشنهاد دقیق‌ترین تراپیست از بین بیش از 100 درمانگر، لازم است به چند سوال کوتاه پاسخ دهید تا نیازها و
            شرایط شما را بشناسیم.
          </div>
          <div class="actionStep">
            <v-btn class="nextBtn" @click="nextIntroStep" color="#30A778" block id="confirm_btn" elevation="0">
              بعدی
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div class="matchArea">
      <div class="invisibleStep step5 text-center" v-if="loadPsychologyFieldsSelectedForm && psychologyFields"
           style="cursor: pointer">
        <h4 class="titleQuestionItem">{{ $t('matchMaking.chooseFieldQuestion') }}</h4>

        <v-row class="mt-2 pa-0 ma-0 mt-5" justify="center" no-gutters>
          <v-col class="text-center pa-0 ma-0" cols="12" lg="12 " v-for="(item , i) in psychologyFields" :key="i">
            <div class="optionItem"
                 v-ripple
                 :id="`${item.id}_psychology`"
                 :class="psychologyFieldsSelected == item.id ? 'selectableItemActive' : ''"
                 @click="setPsychologyFieldsSelected(item.id)">
              <template v-if="$vuetify.rtl">
                {{ item.title }}
              </template>
              <template v-else>
                {{ item.en_title }}
              </template>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="invisibleStep step6 text-center" style="cursor: pointer">
        <h4 class="titleQuestionItem">
          آیا دانشجو هستید؟
        </h4>

        <v-row class="mt-2 pa-0 ma-0 mt-5" justify="center" no-gutters>
          <v-col class="text-center pa-0 ma-0" cols="12" lg="12 " v-for="(item , i) in studentOption" :key="i">
            <div class="optionItem"
                 v-ripple
                 :id="`${item.id}_psychology`"
                 :class="isStudent == item.value ? 'selectableItemActive' : ''"
                 @click="setIsStudent(item.value)">
              <template v-if="$vuetify.rtl">
                {{ item.title }}
              </template>
              <template v-else>
                {{ item.en_title }}
              </template>
            </div>
          </v-col>
        </v-row>
      </div>


      <v-fade-transition>
        <div class="generalHint mt-10" v-if="showHintMessages">
          {{ $t('matchMaking.hintTitle') }}
          <br>
          {{ $t('matchMaking.hintDescription[0]') }}
          <br>
          {{ $t('matchMaking.hintDescription[1]') }}
        </div>
      </v-fade-transition>


      <div class="invisibleStep " :style="showHintMessages && 'font-size: 18px;font-weight:bolder'"
           :class="`step${this.currentStep}`" v-if="questionRender != null && currentStep > 6">
        <div class="titleQuestionItem">
          <template v-if="questionRender.answer_record">
            <template v-if="$vuetify.rtl">
              {{ questionRender.answer_record.question.q_text }}
            </template>
            <template v-else>
              {{ questionRender.answer_record.question.q_en_text }}
            </template>
          </template>
        </div>
        <v-form ref="matchMaking" class="mt-5" v-if="questionRender.answer_record">
          <option-handler-match-making
              :call-change-in-option="callChangeInOption"
              :options="questionRender.answer_record"
              :type="questionRender.answer_record.question.vue_type"
              @prepareData="prepareData"
          />
        </v-form>

      </div>
      <div class="actionMobile" v-if="currentStep >= 7">
        <div class="doneBtn" v-if="$vuetify.breakpoint.mdAndDown">
          <v-btn class="nextBtn" color="#3CBE8B" block id="confirm_btn" elevation="0" @click="callOptionChanges">
            سوال بعد
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
// import {ajaxGet, ajaxPost} from "@/utilities";
import {EventBus} from "@/event-bus";
import gsap from "gsap";
import OptionHandlerMatchMaking from "@/components/MatchMaking/OptionHandlerMatchMaking";
import {isValidJourneyToken, resolveJourneyToken} from "@/utils/journeyToken";

export default {
  components: {OptionHandlerMatchMaking},
  props: {
    language: {
      default: 'fa'
    },
    next: Boolean,
    sessionToken: {
      type: String,
      default: null
    },
    initialAnswerRecord: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      introSlider: 1,
      psychology_fields: {
        individual: '1',
        couple: 2,
        child: 4
      },
      callChangeInOption: false,
      showHintMessages: false,
      loadPsychologyFieldsSelectedForm: true,
      psychologyFields: [
        {
          id: 1,
          title: 'فردی',
          en_title: 'Individual'
        },
        {
          id: 2,
          title: 'خانواده و زوج',
          en_title: 'Family and couple'
        },
        {
          id: 4,
          title: 'کودک و نوجوان',
          en_title: 'Kids and teenagers'
        },
      ],
      studentOption: [
        {
          id: 1,
          title: 'بله',
          value: 1
        },
        {
          id: 2,
          title: 'خیر',
          value: 0
        },
      ],
      isStudent: null,
      questionRender: null,
      psychologyFieldsSelected: null,
      currentStep: 1,
      payloadBody: null,
      user_m_test_id: null,
      seekbar: 0,
    }
  },
  methods: {
    resolveSessionToken() {
      const token = resolveJourneyToken(this.sessionToken)
      if (token) {
        return Promise.resolve(token)
      }
      return new Promise((resolve, reject) => {
        this.$emit('ensureJourneyToken', (nextToken) => {
          if (isValidJourneyToken(nextToken)) {
            resolve(nextToken)
          } else {
            reject(new Error('journey token missing'))
          }
        })
      })
    },
    runWithSessionToken(work) {
      return this.resolveSessionToken()
        .then(work)
        .catch((error) => {
          const status = error && error.response && error.response.status
          if (status === 400 || (error && error.message === 'journey token missing')) {
            this.$emit('restartTest')
          }
        })
    },
    backInMatchMaking() {
      // Only handle intro slider back
      const step2Visible = getComputedStyle(document.querySelector('.step2')).display !== 'none';
      if (step2Visible) {
        // Inside intro: go to previous slide if possible
        if (this.introSlider > 1) {
          const current = `.introStep${this.introSlider}`;
          const prevIndex = this.introSlider - 1;
          const prev = `.introStep${prevIndex}`;
          this.seekbar = this.seekbar - 5
          this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', this.seekbar)
          gsap.to(current, {
            x: 50, opacity: 0, display: 'none', onComplete: () => {
              this.introSlider = prevIndex;
              this.$nextTick(() => {
                gsap.fromTo(prev, {x: -50, opacity: 0, display: 'none'}, {x: 0, opacity: 1, display: 'block'});
              })
            }
          });
        }
        return;
      }
      // If already moved to questions (step5), back should bring intro (last slide) back
      if (!step2Visible && this.currentStep === 5) {
        gsap.to('.step5', {
          x: 50, opacity: 0, display: 'none', onComplete: () => {
            this.introSlider = 3;
            this.$nextTick(() => {
              gsap.fromTo('.step2', {x: -50, opacity: 0, display: 'none'}, {x: 0, opacity: 1, display: 'block'});
            })
          }
        });
      }
    },
    nextIntroStep() {

      const current = `.introStep${this.introSlider}`;
      const nextIndex = this.introSlider + 1;

      this.$emitEvent('addMatchMakingToHeaderIncludes')
      this.seekbar = this.seekbar + 5
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', this.seekbar)

      gsap.to('.step2', {
        x: -50, opacity: 0, display: 'none', onComplete: () => {
          this.currentStep = 5;
          let step = '.step5'
          if (localStorage.getItem('psychology_field_id')) {
            step = '.step6'
            this.currentStep = 6;
          }
          this.$nextTick(() => {
            gsap.fromTo(step, {x: 50, opacity: 0, display: 'none'}, {x: 0, opacity: 1, display: 'block'});
          })
        }
      })

    },
    callOptionChanges() {
      this.callChangeInOption = true
      this.$nextTick().then(() => {
        this.callChangeInOption = false
      })

    },
    checkUserHasPendingTest() {
      if (this.$store.getters.userIsLoggedIn || localStorage.getItem('user_token_matchMaking') != 'undefined') {
        this.$emitEvent('setLoading', true)
        this.requesting('match_making', 'initTest', '', '', {
          'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking'),
        }).then((resp) => {
          if (resp.status_code == 404) {
            localStorage.setItem('user_token_matchMaking', null)
            this.getPsychologyFields()
          } else {
            this.loadPsychologyFieldsSelectedForm = false
            this.getQuestions();
          }
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }
    },
    getPsychologyFields() {
      this.toInVisible();
      this.$emitEvent('setLoading', true)
      this.requesting('match_making', 'getPsychologyFields', '', '', {
        'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking')
      }).then((resp) => {
        this.psychologyFields = resp.data
        this.nextStep()
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    getQuestions() {
      this.showHintMessages = false
      this.$emitEvent('setLoading', true)
      let urlName = 'initTestWithOutCheck'
      let param = {}
      let header = {
        'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking')
      }
      if (this.psychologyFieldsSelected != null) {
        urlName = 'initTestWithPsychology'
        param = {
          psychology_field_id: this.psychologyFieldsSelected
        }
        header = {}
      }
      this.requesting('match_making', urlName, param, {}, header).then((resp) => {
        if (resp.status_code == 206) {
          this.$emitEvent('setLoading', true)
          // this.getResult();
          this.$emit('matchMakingTestEnd', {})
        } else {
          this.$emitEvent('setLoading', false)
          localStorage.setItem('user_token_matchMaking', resp.data.token)
          console.log(localStorage.getItem('user_token_matchMaking'), '12346780]')
          console.log(resp, 'hre')
          this.user_m_test_id = resp.data.answer_record.user_m_test_id
          this.nextStep();
          this.questionRender = resp.data
          console.log(this.questionRender)
        }
      })
    },
    submitAnswer() {
      this.$emitEvent('setStepValue', {
        key: 'temp',
        value: null,
        nextStep: false
      })
      this.seekbar = this.seekbar + 6
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', this.seekbar)
      if (Object.keys(this.payloadBody).length === 0 || this.payloadBody.answers.length === 0 || this.payloadBody.answers[0] == undefined) {
        this.$emitEvent('setStepValue', {
          key: 'temp',
          value: null,
          nextStep: false
        })
        this.$emitEvent("notify", {
          title: this.$t('matchMaking.pleaseAnswer'),
          color: "red",
        });
        return;
      }
      this.$emitEvent('setLoading', true)
      this.toInVisible(() => {
        if (this.questionRender.answer_record.question_id == 1) {
          this.storeFirstQuestionOption()
        }
        this.questionRender = null
        this.showHintMessages = false
        this.runWithSessionToken((token) => {
          this.payloadBody.token = token
          return this.requesting('match_making', 'submitAnswer', '', this.payloadBody, {}).then((resp) => {
            if (!resp || resp.type === 'FAILURE') {
              if (resp && resp.data && resp.data.token) {
                this.$emit('restartTest')
              }
              return
            }
            if (resp.status_code == 206) {
              this.$emit('matchMakingTestEnd', {})
            } else {
              this.$emit('setLoading', false)
              this.user_m_test_id = resp.data.answer_record.user_m_test_id
              this.nextStep();
              this.questionRender = resp.data
            }
          })
        }).finally(() => {
          this.$emitEvent('setLoading', false)
          this.payloadBody = {}
        })
      })
    },
    storeFirstQuestionOption() {
      localStorage.setItem('firstQuestionMatchMaking', this.payloadBody.answers[0].question_option_id)
    },
    prepareData(val) {
      this.payloadBody = val
      EventBus.$emit('setStepValue', {
        key: 'temp',
        value: this.payloadBody,
      })
      this.submitAnswer()
    },
    getResult() {
      this.$emitEvent('setLoading', true)
      this.requesting('match_making', 'getTestResult', '', {
        'user_m_test_id': this.user_m_test_id,
      }, {}).then((resp) => {
        this.$emit('matchMakingTestEnd', {})
        // this.matchMakingStepper = 4
        // this.$router.push({name: "preorder", params: {orderId: 68}})
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    loadingHandler(val) {
      this.$nextTick().then(() => {
        this.loading = val
      })
    },
    nextStep() {
      gsap.to(`.step${this.currentStep}`, {x: -50, opacity: 0, display: 'none'}).then(() => {
        this.currentStep++;
        console.log(this.currentStep, localStorage.getItem('psychology_field_id'))
        if (this.currentStep == 5 && localStorage.getItem('psychology_field_id')) {
          this.currentStep++;
        }
        if (this.questionRender) {
          if (this.questionRender.answer_record.question_id == 25) {
            // this.showHintMessages = true
          }
        }
        this.$nextTick().then(() => {
          gsap.fromTo(`.step${this.currentStep}`, {x: 50, opacity: 0, display: 'none'}, {
            x: 0,
            opacity: 1,
            display: "block"
          })
        })
      });
    },
    toInVisible(callBack = function () {
    }) {
      gsap.to(`.step${this.currentStep}`, .5, {x: -50, opacity: 0, display: 'none'}).then(() => {
        callBack();
      })
    },
    toVisible() {
      setTimeout(() => {
        this.currentStep++;
        gsap.fromTo(`.step${this.currentStep}`, .5, {x: 50, opacity: 0, display: 'none'}, {
          x: 0,
          opacity: 1,
          display: "block"
        }).then(() => {
          console.log(`.step${this.currentStep}`)
        })
      }, 500)
    },
    setPsychologyFieldsSelected(val) {
      this.$emitEvent('setLoading', true)
      this.psychologyFieldsSelected = val
      this.runWithSessionToken((token) => {
        return this.requesting('match_making', 'updatePsychologyFiled', '', {
          token,
          psychology_field_id: this.psychologyFieldsSelected
        }).then((resp) => {
          if (!resp || resp.type === 'FAILURE') {
            if (resp && resp.data && resp.data.token) {
              this.$emit('restartTest')
            }
            return
          }
          localStorage.setItem('psychology_field_id', this.psychologyFieldsSelected)
          this.nextStep()
          this.seekbar = this.seekbar + 5
          this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', this.seekbar)
        })
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    setIsStudent(val) {
      this.$emitEvent('setLoading', true)
      this.isStudent = val
      this.runWithSessionToken((token) => {
        return this.requesting('match_making', 'updateIsStudent', '', {
          token,
          is_student: this.isStudent
        }).then((resp) => {
          if (!resp || resp.type === 'FAILURE') {
            if (resp && resp.data && resp.data.token) {
              this.$emit('restartTest')
            }
            return
          }
          this.$emit('updateFlowState')
          this.nextStep()
          this.seekbar = this.seekbar + 5
          this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', this.seekbar)
        })
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    }
    //   this.psychologyFieldsSelected = val
    //   if (this.currentStep == 2 && this.psychologyFieldsSelected != null) {
    //     return this.getQuestions()
    //   } else {
    //     return this.submitAnswer()
    //   }
    // }
  },
  computed: {
    btnMethod() {

    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL
    }
  },
  watch: {
    introSlider(val) {
      if (val > 1) {
        this.$emitEvent('removeMatchMakingFromHeaderIncludes')
      } else {
        this.$emitEvent('addMatchMakingToHeaderIncludes')

      }
    },
    next(val) {
      if (val) {
        this.submitAnswer()
      }
    },
    initialAnswerRecord: {
      handler(val) {
        if (val) {
          this.user_m_test_id = val.user_m_test_id
          this.questionRender = {answer_record: val}
          this.$nextTick().then(() => {
            this.toVisible()
          })
        }
      },
      immediate: false
    }

  },
  mounted() {
    this.$onEvent('backInMatchMaking', this.backInMatchMaking)
    if (this.initialAnswerRecord) {
      this.user_m_test_id = this.initialAnswerRecord.user_m_test_id
      this.questionRender = {answer_record: this.initialAnswerRecord}
      this.$nextTick().then(() => {
        this.toVisible()
      })
    }
    if (this.$route.query.flow) {
      this.runWithSessionToken((token) => {
        return this.requesting('match_making', 'updatePsychologyFiled', '', {
          token,
          psychology_field_id: this.psychology_fields[this.$route.query.flow]
        }).then(() => {
          localStorage.setItem('psychology_field_id', this.psychology_fields[this.$route.query.flow])
        })
      })
    }
    // this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 1)

    // if (this.currentS  tep == 1) {
    //   this.checkUserHasPendingTest()
    // }
    // if (this.currentStep == 2 && this.psychologyFieldsSelected != null) {
    //   return this.getQuestions()
    // } else {
    //   return this.submitAnswer()
    // }
  }
}
</script>

<style scoped>

@media screen and (max-width: 967px ) {
  .step2 {
    width: 100%;
    overflow-x: hidden;
  }

  .introStep {
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    overflow-x: hidden;
  }

  .introStep img {
    margin-top: 50px;
    width: 80%;
    max-width: 100%;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }


  .actionStep {
  }


  .stepper-shell {
    max-width: 95% !important;
  }

  .matchArea {
    margin: 0px auto;
    background: white;
    padding: 20px 20px 80px 20px;
    height: 100%;
  }

  .optionItem {
    min-height: 80px !important;
    margin-bottom: 10px !important;
    font-size: 15px !important;

  }

  .titleQuestionItem {
    font-size: 20px !important;
    margin-top: 20px;
  }

  .nextQuestion {

  }

  .actionMobile {
    padding: 16px 20px 15px 20px;
    position: fixed;
    right: 0px !important;
    width: 100% !important;
    left: 0px;
    bottom: 0px;
    background: white;
    box-shadow: 0 -2px 4px 0 rgba(219, 228, 237, 0.40);
    border-radius: 0px !important;
  }

  .nextBtn {
    border-radius: 8px !important;
    margin-top: 0px !important;
  }
}


.actionStep {
  width: 100%;
  margin-top: 30px;
}

.titleStep {
  margin-top: 20px;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
}

.contentStep {
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
}

.nextBtn {
  width: 268px;
  height: 50px !important;
  color: white !important;
  font-size: 17px !important;
  font-weight: 700 !important;
  border-radius: 8px;
  margin-top: 30px;
}

.doneBtn {
  border-radius: 8px !important;
}

.generalHint {
  line-height: 25pt;
  font-size: 15px;
}

.selectableItem {
  height: 100%;
  width: 100%;
  font-size: 10pt;
  border-radius: 10px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  background: url("../../assets/matchMaking/backitem.png") no-repeat;
  background-size: cover;
  border: solid 2px #d1dcff;
  position: relative;
  margin: auto;

}


.v-stepper {
  box-shadow: none !important;
}

.matchArea {
  overflow-x: hidden;
  width: 100%;
}

.main-container-c {
  font-size: 24px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 100% !important;
  flex-direction: column;
  z-index: 3 !important;
  transition: all .3s linear;
}

.main-background {
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #f9ffff !important;
  z-index: 1;
}

.bg-circles {
  position: absolute;
  z-index: 2;
  filter: blur(46px);
  -webkit-filter: blur(46px);
}

.bg-circles.aqua-circle {
  top: -10%;
  left: -5%;
  width: 30%;
}

.bg-circles.green-circle {
  bottom: 12%;
  right: -10%;
  width: 20%;
}

.bg-circles.purple-circle {
  bottom: -15%;
  left: -5%;
  width: 20%;
}

.flex-navigation {
  width: 100%;
  z-index: 10;
  align-self: flex-start;
}

.stepper-shell {
  /*width: 60%;*/
  height: 80%;
  max-height: 700px;
  box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.06);
  background-color: #fff;
  border-radius: 20px;
}


.stepper {
  height: 100%;
  margin: 10px 10px 0 10px;
  position: relative;
  border-radius: 20px;
  overflow-x: hidden !important;
}

.invisibleStep {
  opacity: 0;
  display: none;
}


.stepper-item-colored {
  background-color: #f5faff;
}

.selectableItem {
  font-size: 12pt;
  border: 1px solid #ededed;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.3s;

}

.selectableItemActive {
  border: 3px solid #4576d8;
}

.optionItem:hover {
  //transition: all 0.3s;
  border-color: #30a878 !important;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.activeOption {
  border: 2px solid #30a878;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.actionArea {
  position: absolute;
  bottom: 40px;
  right: 10px;
  left: 10px;
  text-align: center;
}

.start-btn {
  height: 35px !important;
  color: #3CBE8B;
  border-radius: 10px;
  transition: background-color .3s linear;
  font-weight: bolder;
  font-size: 15pt;
}

.start-btn:hover {
  background-color: #daf5eb;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.3s;
  transform: translateY(0);
  opacity: 1;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(10px);
}

.titleQuestionItem {
  color: #212121;
  text-align: center;
  /* Title/Large/Bold24 */
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.descQuestionItem {
  color: #212121;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 10px;
}

.greenBox {
  color: #30A778;
  text-align: right;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  border-radius: 8px;
  border: 1px solid #39C990;
  background: rgba(215, 244, 233, 0.50);
  border-radius: 8px;
  padding: 14px 16px;

}

.nextQuestion {
  border-radius: 8px;
  background: #39C990 !important;
  color: white;
  height: 48px !important;
  font-weight: 700;
  font-size: 16px;
}

.optionItem {
  display: flex;
  height: 60px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid #E1E1E1;
  background: #FFF;
  //transition: all 0.3s;
  cursor: pointer;
  margin-bottom: 13px;
}

.activeOption {
  border: 2px solid #39C990;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.titleQuestionItem {
  color: #212121;
  text-align: center;
  /* Title/Large/Bold24 */
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.radioItem {
  font-size: 14px;
  transition: all 0.3s;
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid #E1E1E1;
  background: #FFF;
  transition: all 0.3s;
  cursor: pointer;
}
</style>